import { Component, Input, OnInit, OnChanges, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '@k12/navigation';
import { Subject, takeUntil } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-user-record-view-task',
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule],
  templateUrl: './user-record-view-task.component.html',
  styleUrls: ['./user-record-view-task.component.scss']
})
export class UserRecordViewTaskComponent implements OnInit, OnChanges, OnDestroy {
  // Input for services that need to be injected from the consuming application
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() userRecordService: any;

  @Output() formSubmit = new EventEmitter<boolean>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  personaId: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userId: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userData: any = null;
  accountId: string | null = null;
  private routeUnsubscribe = new Subject<void>();

  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private router: Router,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private route: ActivatedRoute,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    // Get account ID from route parameters
    this.route.params.pipe(takeUntil(this.routeUnsubscribe)).subscribe((params) => {
      this.accountId = params['id'] || null;
      this.userId = this.accountId;
    });

    if (history.state && history.state['personaId']) {
      this.personaId = history.state['personaId'];
    }

    if (history.state && history.state['providerId']) {
      this.userId = history.state['providerId'];
      this.accountId = this.userId;
    }
    this.getUserDataForBreadcrumbs();

    document.documentElement.scrollTop = 0;
  }

  ngOnDestroy(): void {
    this.routeUnsubscribe.next();
    this.routeUnsubscribe.complete();
    this.breadcrumbService.clearDynamicBreadcrumbs();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnChanges(): void {}

  // Method to get user data and set breadcrumbs
  private getUserDataForBreadcrumbs() {
    if (this.userId && this.userRecordService) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.userRecordService.getProviderDetails(this.userId).subscribe((res: any) => {
        this.userData = res;
      });
    }
    this.setBreadcrumbsForViewTask();
  }

  // Method to set breadcrumbs for the view task page
  private setBreadcrumbsForViewTask() {
    if (this.userData && this.userData.firstName && this.userData.lastName) {
      const userName = `${this.userData.firstName} ${this.userData.lastName}`;
      // Set breadcrumbs for user record and view task pages
      // eslint-disable-next-line sonarjs/no-duplicate-string
      this.breadcrumbService.setNestedDynamicBreadcrumbs('/work-queue', this.userId, userName, undefined, 'View Task');
    } else if (this.userRecordService) {
      const routeSegments = this.router.url.split('/');
      const userId = routeSegments[2];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.userRecordService.getProviderDetails(userId).subscribe((res: any) => {
        if (res) {
          if (res.businessName) {
            this.breadcrumbService.setNestedDynamicBreadcrumbs(
              '/work-queue',
              userId,
              res.businessName,
              undefined,
              'View Task'
            );
          } else if (res.firstName && res.lastName) {
            const userName = `${res.firstName} ${res.lastName}`;
            this.breadcrumbService.setNestedDynamicBreadcrumbs('/work-queue', userId, userName, undefined, 'View Task');
          }
        }
      });
    }
  }

  submitForm(success: boolean): void {
    if (success) {
      this.router.navigate(['/work-queue', this.userId]);
    }
    this.formSubmit.emit(success);
  }
}

